<script setup>
import { useRouter } from "vue-router";

const router = useRouter();

const handleMain = async () => {
  // Перенаправление на главную страницу
  router.push("/");
};
</script>

<template>
  <div>
    <header class="sticky top-0 left-0 w-full z-50 py-2">
      <!-- prettier-ignore   -->
      <nav class="container w-full max-w-[1685px] mx-auto px-4 sm:px-8 py-2 flex
      items-center justify-between">
        <div class="flex items-start space-x-4">
          <a class="text-black font-bold text-2xl cursor-pointer"
          @click="handleMain">
            HandBox
          </a>
        </div>
        <div class="flex items-end space-x-4">
          <a class="text-black">
            Личный кабинет
          </a>
        </div>
      </nav>
    </header>
  </div>
</template>
